import React from 'react'
import SearchPicker from '../common/SearchPicker'

const ProductPicker = (props) => {

    const { state } = props

    const option = (product) =>
        <div>
            <label className='block'>Ürün Kodu : {product.collectionCode} </label>
            <label className='block mb-1'>Ürün Adı : {product.collectionName} </label>
            {product.color && <><label className='block'>Renk Kodu : {product.color.code} </label> <label className='block mb-1'>Renk Adı : {product.color.name} </label></>}
            {product.weight && <><label className='block mb-1'>Gramaj Adı : {product.weight.name} </label></>}
            {product.pattern && <><label className='block'>Desen Kodu : {product.pattern.code} </label> <label className='block mb-1'>Desen Adı : {product.pattern.name} </label></>}
        </div>

    return (
        <SearchPicker
            {...props}
            value={state ? `${state?.collectionCode}, ${state?.collectionName}${state?.color ? `, ${state.color.code}, ${state.color.name}` : ""}${state?.weight ? `, ${state.weight.code}, ${state.weight.name}` : ""}${state?.pattern ? `, ${state.pattern.code}, ${state.pattern.name}` : ""}` : ""}
            option={(product) => option(product)}
        />
    )
}

export default ProductPicker